import { CaretUp, CaretDown, CaretUpDown } from "@phosphor-icons/react";

/**
 * Clickable table-header cell. Cycles through: no-sort → asc → desc → no-sort.
 * Props:
 *   field: the backend-recognised sort_by key
 *   sortBy: currently active sort field
 *   sortDir: "asc" | "desc" | null
 *   onChange(field, dir): called with new sort state (dir=null clears)
 *   align: "left" | "right"
 */
export default function SortableHeader({ field, label, sortBy, sortDir, onChange, align = "left", testid }) {
  const active = sortBy === field;
  const nextDir = !active ? "asc" : sortDir === "asc" ? "desc" : null;
  const onClick = () => onChange(nextDir === null ? null : field, nextDir);
  const Arrow = !active ? CaretUpDown : sortDir === "asc" ? CaretUp : CaretDown;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid || `sort-${field}`}
      className={`inline-flex items-center gap-1 uppercase tracking-widest text-[10px] ${
        active ? "text-zinc-900 font-semibold" : "text-zinc-500 hover:text-zinc-900"
      } ${align === "right" ? "flex-row-reverse" : ""}`}
    >
      <span>{label}</span>
      <Arrow size={11} weight={active ? "bold" : "regular"} className={active ? "text-emerald-700" : ""} />
    </button>
  );
}
